'use strict';

var SelectOnClickInputDirective = function () {

  var link = function link (scope, el) {
    el[0].readOnly = true;

    el.on('click', function($event) {
      var elToSelect = $event.currentTarget;

      elToSelect.readOnly = false;
      elToSelect.setSelectionRange(0, 999);
      elToSelect.readOnly = true;
    });
  };

  return {
    link: link
  };
};

module.exports = SelectOnClickInputDirective;



// WEBPACK FOOTER //
// ./src/app/dash/directives/SelectOnClickInput.js